import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { debunkList } from "@/mocks/debunk";

export default function DebunkTeaser() {
  return (
    <section className="border-b border-background-200 bg-secondary-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="辟谣汇总"
          title="已经被澄清的传闻，别再转第二次"
          description="以下条目均出现了官方回应或硬反证。传播前先看一眼，能省下很多解释成本。"
          action={{ label: "全部辟谣", to: "/debunk" }}
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {debunkList.slice(0, 3).map((item) => (
            <article
              key={item.id}
              className="flex flex-col border border-secondary-200 rounded-card bg-background-50 p-5"
            >
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-control bg-secondary-500 text-background-50 text-[11px] font-medium">
                  <i className="ri-shield-check-line"></i>
                  已澄清
                </span>
                <span className="font-mono-num text-[11px] text-foreground-400">{item.date}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 leading-snug">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                传闻：{item.rumor}
              </p>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed line-clamp-3">
                {item.result}
              </p>
              <p className="mt-auto pt-4 flex items-center gap-2 text-[11px] text-secondary-700">
                <i className="ri-verified-badge-line"></i>
                {item.officialSource}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs text-foreground-500">
          仍有疑问？
          <Link to="/contact" className="text-primary-600 hover:text-primary-700 ml-1">
            把反证材料发给我们
          </Link>
          ，核实后会公开更新结论。
        </p>
      </div>
    </section>
  );
}